import styled from "styled-components";

export const Container = styled.div`
  margin-top: 64px;
  margin-left: 64px;
`;
